import {Component} from '@angular/core';
import {ToastService} from '../../../services/toast.service';

@Component({
  selector: 'si-documentation-accordion',
  templateUrl: './documentation-accordion.component.html',
  styleUrls: ['./documentation-accordion.component.scss']
})
export class DocumentationAccordionComponent{

  constructor(
    private toastService: ToastService
  ) {
  }

  async onClickInfoIconAccordion(event: Event): Promise<void> {
    event.stopPropagation();
    await this.toastService.success('Click');
  }
}
